import { render, staticRenderFns } from "./SetupTaskRow.vue?vue&type=template&id=1d541ec8"
import script from "./SetupTaskRow.vue?vue&type=script&lang=js"
export * from "./SetupTaskRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports